import { combineReducers } from "redux";
import { authReducer } from "./reducers/authReducer";
import { sidebarReducer } from "./reducers/sidebarReducer";

export const rootReducer = combineReducers({
  auth: authReducer,
  collapsed: sidebarReducer,
});